export const GET_MILESTONE_AGGREGATE = () => `/transaction/aggregated-milestones`;

export const ADD_MILESTONE_AGGREGATE = (transactionId) =>
  `/transaction/${transactionId}/addMilestone`;
